module.exports = __webpack_public_path__ + "assets/9dd298fad8217742dcd5d65f06b189ed.mp4";